/* eslint-disable @next/next/no-img-element */
import { useState, useMemo, useEffect } from "react";
import Link from "next/link";
import PropTypes from "prop-types";
import Cookies from "js-cookie";
import NavItems from "@/components/NavItems";
import Styles from "./index.module.scss";
import { HiChevronUp, HiChevronDown } from "react-icons/hi2";
import { IoLocationSharp } from "react-icons/io5";
import { IoMdMail } from "react-icons/io";
import { TfiWorld } from "react-icons/tfi";
import { useRouter } from "next/navigation";

const WorldWideMenu = ({ world, visible, setIsHovered }) => {
  const router = useRouter();
  const [open, setOpen] = useState(false);
  const [countryOpen, setCountryOpen] = useState(false);
  const [selectedCountryLabel, setSelectedCountryLabel] = useState("");

  const {
    items: [
      {
        fields: {
          topNav: [
            {
              fields: {
                navItems: [
                  {
                    fields: {
                      url: worldMenuItemUrl = "/",
                      ariaLabel = "",
                      label: worldMenuItemLabel = "",
                    } = {},
                  } = {},
                ] = [],
                navItems: topNavMenu = [],
              } = {},
            } = {},
          ] = [],
        } = {},
      } = {},
    ] = [],
    items: worldItems = [],
  } = world || {};

  const SELECTED_COUNTRY_COOKIE = "selectedCountry";
  const COOKIE_OPTIONS = { expires: 1, sameSite: "Lax", path: "/" };

  const saveSelectedCountry = (countryName, region) => {
    Cookies.set(
      SELECTED_COUNTRY_COOKIE,
      JSON.stringify({ countryName, region }),
      COOKIE_OPTIONS
    );
  };

  useEffect(() => {
    const storedCountry = Cookies.get(SELECTED_COUNTRY_COOKIE);
    if (storedCountry) {
      setSelectedCountryLabel(JSON.parse(storedCountry).countryName);
    } else {
      saveSelectedCountry("Asia Pacific", "APAC");
    }
  }, []);

  const topNavItems = useMemo(() => topNavMenu?.slice(1) || [], [topNavMenu]);

  const handleCountrySelect = fields => {
    const { label = "", url = "" } = fields || {};
    saveSelectedCountry(label, url);
    setSelectedCountryLabel(label);
    setCountryOpen(false);
    const params = new URLSearchParams(window.location.search);
    if (params.get("country")) {
      params.delete("country");
      const queryString = params.toString();
      const newURl = `${window.location.pathname}${queryString ? `?${queryString}` : ""}`;
      window.location.href = newURl;
    } else {
      window.location.reload();
    }
    return;
  };

  useEffect(() => {
    const hideMenuOnScroll = () => {
      setOpen(false);
    };

    window.addEventListener("scroll", hideMenuOnScroll);

    return () => {
      window.removeEventListener("scroll", hideMenuOnScroll);
    };
  }, []);

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => {
        setIsHovered(false);
        // setOpen(false);
        setCountryOpen(false);
      }}
      onFocus={() => setIsHovered(true)}
      onBlur={e => {
        // Don't close if focus is still inside this wrapper (e.g. moving to a dropdown item)
        if (e.currentTarget.contains(e.relatedTarget)) return;
        setIsHovered(false);
        setOpen(false);
        setCountryOpen(false);
      }}
      className={`hidden lg:block ${
        visible
          ? "translate-y-0 opacity-100 pointer-events-auto"
          : "-translate-y-full opacity-0 pointer-events-none"
      } ${Styles.worldWideMenuContainer}`}
    >
      <div className="h-[31.8px] bg-[#232323] text-[#b5b5b5]">
        <div className="flex justify-between flex-rows max-w-screen-lg mx-auto px-[10px]">
          <div className="flex px-6 worldwide-primary-nav pt-[6px] text-[#fff]">
            <Link href={worldMenuItemUrl || "/"} legacyBehavior>
              <>
                <TfiWorld size={18} />
                <button
                  type="button"
                  className="text-[13px] font-normal cursor-pointer hover:text-white font-[HelveticaLight, Helvetica, sans-serif] no-underline text-[#bebebe] hover:text-[#fff]"
                  style={{
                    paddingRight: "15px",
                    paddingLeft: "6px",
                    background: "transparent",
                    border: "none",
                  }}
                  aria-label={ariaLabel}
                  onClick={() => {
                    setOpen(prev => !prev);
                  }}
                >
                  {worldMenuItemLabel}
                </button>
                {open ? (
                  <HiChevronUp
                    className="text-[#bebebe] hover:text-[#fff] cursor-pointer"
                    size={20}
                    onClick={() => {
                      setOpen(prev => !prev);
                    }}
                  />
                ) : (
                  <HiChevronDown
                    className="text-[#bebebe] hover:text-[#fff] cursor-pointer"
                    size={20}
                    onClick={() => {
                      setOpen(prev => !prev);
                    }}
                  />
                )}
              </>
            </Link>
          </div>
          <div className="flex flex-rows text-[#bebebe]">
            {topNavItems?.map((item, index) => {
              if (index === 0) {
                const secondaryNavigation =
                  item?.fields?.secondaryNavigation || [];
                const defaultCountryLabel =
                  secondaryNavigation?.[0]?.fields?.heading?.[0]?.fields?.label;
                const buttonLabel = selectedCountryLabel || defaultCountryLabel;

                return (
                  <div
                    key={item?.sys?.id || index}
                    className={Styles.countryDropdownWrapper}
                  >
                    <div className="flex items-center pr-[15px] border-r-2 border-r-[#333]">
                      <button
                        type="button"
                        className="cursor-pointer hover:text-white font-[HelveticaLight, Helvetica, sans-serif] no-underline text-[13px] leading-[30px] font-normal h-[30px] hover:!no-underline mr-[5px]"
                        style={{ background: "transparent", border: "none" }}
                        aria-expanded={countryOpen}
                        onClick={() => {
                          setCountryOpen(prev => !prev);
                        }}
                      >
                        {buttonLabel}
                      </button>
                      {countryOpen ? (
                        <HiChevronUp
                          className="text-[#bebebe] hover:text-[#fff] cursor-pointer"
                          size={20}
                          onClick={() => {
                            setCountryOpen(prev => !prev);
                          }}
                        />
                      ) : (
                        <HiChevronDown
                          className="text-[#bebebe] hover:text-[#fff] cursor-pointer"
                          size={20}
                          onClick={() => {
                            setCountryOpen(prev => !prev);
                          }}
                        />
                      )}
                    </div>

                    {secondaryNavigation.length > 0 && (
                      <div
                        className={`${Styles.countryDropdownCurtain} ${
                          countryOpen ? Styles.open : ""
                        }`}
                      >
                        <div className={Styles.countryDropdownCurtainInner}>
                          <ul className={Styles.countryDropdownList}>
                            {secondaryNavigation.map((subItem, subIndex) => (
                              <li
                                key={subItem?.sys?.id || subIndex}
                                className={Styles.countryDropdownItem}
                              >
                                <button
                                  type="button"
                                  className={Styles.countryDropdownButton}
                                  onMouseDown={e => {
                                    e.preventDefault();
                                  }}
                                  onClick={() => {
                                    handleCountrySelect(
                                      subItem?.fields?.heading?.[0]?.fields
                                    );
                                  }}
                                >
                                  {subItem?.fields?.heading?.[0]?.fields?.label}
                                </button>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    )}
                  </div>
                );
              }

              return (
                <Link
                  href={item?.fields?.url || "/"}
                  key={item?.sys?.id || index}
                  locale={item?.fields?.url?.replace("/", "")}
                  legacyBehavior
                >
                  <>
                    {index === 1 && (
                      <div className="self-center">
                        <IoLocationSharp size={18} />
                      </div>
                    )}
                    {index === 2 && (
                      <div className="self-center">
                        <IoMdMail size={18} />
                      </div>
                    )}

                    {item?.fields?.mediaItem?.[0]?.fields?.asset?.fields?.file
                      ?.url ? (
                      <a
                        aria-label={item?.fields?.ariaLabel}
                        href={item?.fields?.url}
                        target={
                          item?.fields?.openerType === "New Tab"
                            ? "_blank"
                            : "_self"
                        }
                      >
                        <img
                          className="pr-[15px] pl-[6px] pt-[2px] border-r-2 border-r-[#333] cursor-pointer hover:text-white no-underline h-[28px] hover:!no-underline"
                          src={
                            item?.fields?.mediaItem?.[0]?.fields?.asset?.fields
                              ?.file?.url
                          }
                          alt={item?.fields?.mediaItem?.fields?.altText || ""}
                        />
                      </a>
                    ) : (
                      <a
                        className="pr-[15px] pl-[6px] border-r-2 border-r-[#333] cursor-pointer hover:text-white font-[HelveticaLight, Helvetica, sans-serif] no-underline text-[13px] leading-[30px] font-normal h-[30px] hover:!no-underline"
                        aria-label={item?.fields?.ariaLabel}
                        href={item?.fields?.url}
                      >
                        {item?.fields?.label}
                      </a>
                    )}
                  </>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
      <div className={`accordion-wrapper ${open ? "open" : ""}`}>
        <div className="accordion-inner">
          <div className="accordion-content"></div>
          <section className="max-w-screen-lg mx-auto pl-[2.5rem]">
            <div className="flex justify-between pt-5 ">
              {worldItems.map(item =>
                item?.fields?.primaryNav?.map(i => (
                  <div className="" key={item?.sys?.id}>
                    {i.fields.heading && (
                      <div className="font-[Helvetica-Light,_Helvetica,_sans-serif] flex-nowrap flex leading-[20px] text-[13px] cursor-default lg:pr-[60px]">
                        {i.fields.heading}
                      </div>
                    )}
                    {i?.fields.heading &&
                      i?.fields?.navItems?.map((navItem, index) => (
                        <NavItems
                          key={navItem?.sys?.id || index}
                          navItem={navItem}
                          classNames="hover:text-white text-[#999999] cursor-pointer text-[13px]"
                          linkClass="flex lg:py-[5px] lg:pr-[60px] w-full hover:text-white text-[#999999]"
                        />
                      ))}
                  </div>
                ))
              )}
            </div>
            <hr className="border-t border-[#333] absolute left-0 right-0 bottom-[65px]" />
            <div
              className="flex"
              style={{ color: "#b5b5b5", marginTop: "20px", marginLeft: "4px" }}
            >
              {world?.items
                ? world?.items[0]?.fields?.bottomNav?.fields?.navItems?.map(
                    i => (
                      <ul
                        style={{
                          borderRight: "solid 1px #333",
                          listStyle: "none",
                          textAlign: "left",
                        }}
                        key={i?.fields?.label}
                      >
                        <li>
                          <a
                            href={i.fields.url}
                            target="_blank"
                            rel="noreferrer"
                            style={{ padding: "0px 10px", listStyle: "nono" }}
                          >
                            <img
                              style={{
                                paddingLeft: "10px",
                                paddingRight: "10px",
                              }}
                              alt={i?.fields?.mediaItem[0]?.fields?.altText}
                              aria-label={
                                i?.fields?.mediaItem[0]?.fields?.altText
                              }
                              src={
                                i?.fields?.mediaItem[0]?.fields?.asset?.fields
                                  ?.file?.url
                              }
                            />
                          </a>
                        </li>
                      </ul>
                    )
                  )
                : null}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

WorldWideMenu.propTypes = {
  visible: PropTypes.bool,
  setIsHovered: PropTypes.func,
  world: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        fields: PropTypes.shape({
          topNav: PropTypes.arrayOf(
            PropTypes.shape({
              fields: PropTypes.shape({
                navItems: PropTypes.arrayOf(
                  PropTypes.shape({
                    fields: PropTypes.shape({
                      url: PropTypes.string,
                      label: PropTypes.string,
                      ariaLabel: PropTypes.string,
                      sys: PropTypes.shape({
                        id: PropTypes.string,
                      }),
                    }),
                  })
                ),
              }),
            })
          ),
          primaryNav: PropTypes.arrayOf(
            PropTypes.shape({
              fields: PropTypes.shape({
                internalTitle: PropTypes.string,
                navItems: PropTypes.arrayOf(
                  PropTypes.shape({
                    sys: PropTypes.shape({
                      id: PropTypes.string,
                    }),
                    fields: PropTypes.shape({
                      label: PropTypes.string,
                      url: PropTypes.string,
                      ariaLabel: PropTypes.string,
                      mediaItem: PropTypes.arrayOf(
                        PropTypes.shape({
                          fields: PropTypes.shape({
                            altText: PropTypes.string,
                            asset: PropTypes.shape({
                              fields: PropTypes.shape({
                                file: PropTypes.shape({
                                  url: PropTypes.string,
                                }),
                              }),
                            }),
                          }),
                        })
                      ),
                    }),
                  })
                ),
              }),
            })
          ),
          bottomNav: PropTypes.shape({
            fields: PropTypes.shape({
              navItems: PropTypes.arrayOf(
                PropTypes.shape({
                  fields: PropTypes.shape({
                    label: PropTypes.string,
                    url: PropTypes.string,
                    mediaItem: PropTypes.arrayOf(
                      PropTypes.shape({
                        fields: PropTypes.shape({
                          altText: PropTypes.string,
                          asset: PropTypes.shape({
                            fields: PropTypes.shape({
                              file: PropTypes.shape({
                                url: PropTypes.string,
                              }),
                            }),
                          }),
                        }),
                      })
                    ),
                  }),
                })
              ),
            }),
          }),
        }),
      })
    ),
  }),
};

export default WorldWideMenu;
